import { Col, Row } from "react-bootstrap";

export default function IndianTeamDetails() {
  return (
    <div>
      <Row>
        <Col md={6}>
          <h1>महिला टीम</h1>
          <div className="d-md-none d-flex justify-content-center"></div>
          <div className="d-none d-md-block">
            {/* <iframe
                src="pdf/events/women-team-India-sepaktakraw.pdf"
                style={{
                  width: "100%",
                  height: "500px",
                  border: "none",
                  overflow: "hidden",
                }}
                title="Women Team India"
              ></iframe> */}
            <img
              src={"img/team-india-women-sepaktakraw.jpg"}
              alt="Women's Team"
              style={{ height: "auto", width: "100%", objectFit: "contain" }}
            />
          </div>
        </Col>
        <Col md={6}>
          <h1>पुरुष टीम</h1>
          <div className="d-md-none d-flex justify-content-center"></div>
          <div className="d-none d-md-block">
            {/* <iframe
                src="pdf/events/team-India-men-sepaktakraw.pdf"
                style={{
                  width: "100%",
                  height: "500px",
                  border: "none",
                  overflow: "hidden",
                }}
                title="Men Team India"
              ></iframe> */}
            <img
              src={"img/team-india-men-sepaktakraw.jpg"}
              alt="Women's Team"
              style={{ height: "auto", width: "100%", objectFit: "contain" }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
